import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import * as firebase from 'firebase';

@Component({
  selector: 'app-list-address',
  templateUrl: './list-address.component.html',
  styleUrls: ['./list-address.component.css']
})
export class ListAddressComponent implements OnInit {
  public address: UserAddress[];
  public isLoadingAddress = true;

  constructor(private addressService: AuthenticationService) { }

  ngOnInit() {
    firebase.analytics().logEvent('profil_alamat_page');

    this.getAddressList();
  }

  getAddressList(): void {
    this.addressService.getAddresss(
      (data) => {
        this.address = data;
        this.isLoadingAddress = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
